export enum TimeDuration {
  SECOND = 1000,
  MINUTE = 60 * TimeDuration.SECOND,
  HOUR = 60 * TimeDuration.MINUTE,
  DAY = 24 * TimeDuration.HOUR,
  WEEK = 7 * TimeDuration.DAY,
  REGULAR_YEAR = 365 * TimeDuration.DAY,
  IRREGULAR_YEAR = 366 * TimeDuration.DAY,
}
